import React from "react";


function Education(){
    return(
        <div id = "education">
            <h1>Education</h1>

            <div id = "NITH">
                <h6>2020-2024</h6>
                <p>NIT Hamirpur, HP, India</p>
                <p>Btech; Computer Science and Engineering</p>
            </div>

            <div id = "Gurukul">
                <h6>2018-2020</h6>
                <p>New Gurukul Public School, HP, India</p>
                <p>Schooling</p>
            </div>

            <div id = "HAPS">
                <h6>2018-2020</h6>
                <p>Him Acdemy Public School, HP, India</p>
                <p>Schooling</p>
            </div>
        </div>
    )
}

export default Education;